
import { BookkeepingService } from "@/services";
import Vue from "vue";
import AppMonthSelect from "@/components/common/MonthSelect.vue";

export default Vue.extend({
	data(){
		return {
			dateRange: {
				startMonth: 1,
				endMonth: 12,
			},
			journalId: 0,
		};
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async start(){
			await BookkeepingService.createBookkeepingData(this.dateRange, this.journalId);
			this.$wf.notify(this.$ct("create-bookkeeping-data-started"), "info", 3000, "info-circle");
			this.close();
		}
	},

	components: {
		AppMonthSelect
	},
	i18nEx: {
		componentPrefix: "components.bookkeeping"
	}
});
